/** FAQ content — client-supplied. Homepage uses questions 1–6, /faqs uses all. */
// COPY LOCKED — do not paraphrase without client confirmation. See /app/memory/PRD.md.


export const ALL_FAQS = [
    {
        q: "Is the design really free?",
        a: "Yes. There is no professional design fee for the agreed free-design scope. The service is subject to project feasibility.",
    },
    {
        q: "Do I have to use you for the construction?",
        a: "No. There is no obligation to appoint us to take the design work further or to carry out the construction work.\n\nIf you decide to use another designer or contractor, no retrospective design fee becomes payable.",
    },
    {
        q: "What does the free design service include?",
        a: "The service covers concept / feasibility stage architectural layout drawings.",
    },
    {
        q: "Is a measured survey included?",
        a: "The free design service is based on existing floor plans / estate agent plans that you provide us. Should you require additional services from us that require a site visit, this can be discussed and agreed separately.",
    },
    {
        q: "Does the free service include a planning application?",
        a: "The free service covers design development at concept / feasibility level.\n\nPlanning drawings, planning submission, planning management, statutory fees and specialist consultant services are not included.",
    },
    {
        q: "What happens if I use another designer or builder?",
        a: "You are free to take the issued design forward with another designer or contractor.\n\nThere is no retrospective design fee simply because you choose someone else.",
    },
    {
        q: "What types of project are suitable?",
        a: "Rear extensions, side extensions, loft conversions/extensions and internal reconfigurations.",
    },
    {
        q: "Where do you work?",
        a: "We work across all of London and the surrounding areas.",
    },
    {
        q: "How do you decide whether a project is feasible?",
        a: "Every property and project is different.\n\nWe consider the property, proposed scope, planning and design considerations, budget, programme and overall deliverability.",
    },
    {
        q: "How long does the design process take?",
        a: "Timescales depend on the project scope, the quality of the existing floor plans available at the start, and how quickly design feedback can be exchanged.\n\nWe can give you a more specific indication once we understand the property and the works you are considering. We prefer not to promise a fixed turnaround before we have reviewed your project.",
    },
    {
        q: "Are revisions included?",
        a: "Reasonable design development is included as part of reaching an agreed proposal.\n\nWe do not advertise a fixed number of revisions; the aim is to arrive at a design you are happy to take forward.",
    },
    {
        q: "Are structural calculations included?",
        a: "No. Structural engineering and calculations are separate specialist services.",
    },
    {
        q: "Are Building Regulations drawings included?",
        a: "No. Technical construction information and Building Regulations packages are not included within the free-design scope.",
    },
    {
        q: "Are Party Wall services included?",
        a: "No.",
    },
    {
        q: "Are planning application fees included?",
        a: "No. Local authority and other statutory fees are not included.",
    },
    {
        q: "Are other consultants included?",
        a: "Specialist consultants, surveys, reports and third-party services are not included.",
    },
    {
        q: "Can I build directly from the free drawings?",
        a: "No. The drawings provided as part of the free design service are concept / feasibility stage information only.\n\nPlanning drawings, technical design, structural information and Building Regulations information will be required before construction.",
    },
    {
        q: "Who owns the drawings?",
        a: "Copyright remains with the designer.\n\nOnce issued, the homeowner receives a royalty-free licence to use the drawings in connection with the relevant property, including if they subsequently appoint another designer or contractor.",
    },
];


export const HOMEPAGE_FAQS = ALL_FAQS.slice(0, 6);
